import * as React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import CustomIcon from '@components/shared/CustomIcon';
import modal from '@styles/modal.module.less';
import s from './FloorPlanModal.module.less';

type Props = {
  floorPlanUrl: string;
  onClose: (e: React.MouseEvent) => void;
};

const FloorPlanModal = ({ floorPlanUrl, onClose }: Props) => {
  const { t } = useTranslation('building');

  return (
    <div className={modal.overlay} role="button" onClick={onClose}>
      <Row className={modal.container} justify="center">
        <Col span={20} className={s.modalContainer}>
          <img
            className={s.floorPlan}
            alt={t('availableSpaces.floorPlanTitle')}
            src={floorPlanUrl}
          />
        </Col>
        <CustomIcon
          type="close"
          title="floor-plan-close"
          className={modal.close}
          onClick={onClose}
        />
      </Row>
    </div>
  );
};

export default FloorPlanModal;
